// Internal modules
import { logger } from '@/lib/logger';
import { once } from '@/lib/utils';

export const logWhenDisplayForcedSignupBNPL = once((): void => {
  logger.fpti('bnpl_display_forced_signup_link', {
    state_name: 'bnpl_signup',
    transition_name: 'prepare_pay_later',
  });
});

export const logOnClickForcedSignupBNPL = (): void => {
  logger.fpti('bnpl_click_forced_signup_link', {
    state_name: 'bnpl_signup',
    transition_name: 'process_pay_later',
  });
};

export const logWhenDisplayOptionalGuestBNPL = once((): void => {
  logger.fpti(
    'bnpl_display_optional_guest_link',
    {
      state_name: 'bnpl_guest',
      transition_name: 'prepare_pay_later',
    },
    true,
  );
});

export const logOnClickOptionalGuestBNPL = (): void => {
  logger.fpti(
    'bnpl_click_optional_guest_link',
    {
      state_name: 'bnpl_guest',
      transition_name: 'process_pay_later',
    },
    true,
  );
};
